import { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import Header from "../../components/Header";
import Menu from "../../components/Menu";
import Form from "../../../../../components/shared/Form";
import Settings from "./Settings";
import { usePreferenceMutation } from "../../api/usePreferenceMutation";
import { useCompanyPreferences } from "../../hooks/usePreferences";
import { useElementHeight } from "../../../../../utils/hooks/useElementHeight";

const options: string[] = ["settings"];

function General() {
    const { ref, height } = useElementHeight();
    const [option, setOption] = useState<string>("settings");
    const { mutate, isPending } = usePreferenceMutation("company", "timeSheetGeneral");
    const timeSheetGeneral = useCompanyPreferences("timeSheetGeneral");
    const form = useForm({
        defaultValues: timeSheetGeneral,
        values: timeSheetGeneral === undefined ? undefined : timeSheetGeneral,
        resetOptions: { keepDirtyValues: true },
    });

    const onFinish = (value: typeof timeSheetGeneral) => mutate({ ...timeSheetGeneral, ...value });

    const content = useMemo(() => {
        switch (option) {
            default:
            case "settings":
                return <Settings />;
        }
    }, [option]);

    return (
        <div className="tw-p-5 tw-h-full tw-bg-white tw-rounded-lg">
            <Form className="tw-h-full" form={form} onFinish={onFinish}>
                <div ref={ref} className="tw-flex tw-flex-col">
                    <Header name="general" isLoading={isPending} />
                    <Menu
                        options={options}
                        option={option}
                        setOption={setOption}
                    />
                </div>

                <div className="tw-overflow-auto" style={{ height: `calc(100% - ${height}px - 100px)` }}>
                    {content}
                </div>
            </Form>
        </div>
    );
}

export default General;
